import endSoundAudio from "../assets/sounds/endSound.mp3"
import cardSoundAudio from "../assets/sounds/cardSound.mp3"
import buttonSoundAudio from "../assets/sounds/buttonSound.mp3"

export const endSound = () => {
    const audio = new Audio(endSoundAudio);
    audio.play();
};

export const buttonSound = () => {
    const audio = new Audio(buttonSoundAudio); 
    audio.play();
};

export const drawCardSound = () => {
    const audio = new Audio(cardSoundAudio); 
    audio.play();
};